const Components = {
    BLANK_LINK: "#!",
};

export default Components;